import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../Components/UI/Button';
import PlanoAvisoActivitiesUpgrade from '../../../../Static/images/plano-aviso-activities-upgrade.png';
import tagPro from '../../../../Static/images/tag-pro.png';
import { Icon } from '../../../../Components/UI';
import styles from './ActivitiesCTAUpgrade.module.scss';

interface IActivitiesCTAUpgrade {
  onConfirm: (role: number, order: number) => void;
  order?: number;
  role?: number;
  planFree?: boolean;
}

const ActivitiesCTAUpgrade: FC<IActivitiesCTAUpgrade> = ({
  onConfirm,
  order,
  role,
  planFree
}) => {
  const { t } = useTranslation('activities');
  const isAdmin = role === 1;

  return (
    <div className={styles['tag-wrapper']}>
      <div className={styles['wrapper']}>
        <div className={styles['tag-popularity']}>
          <img src={tagPro} alt={t('ctaUpgrade.tagAlt')} />
        </div>
        <div className={styles['imageWrapper']}>
          <img src={PlanoAvisoActivitiesUpgrade} alt={t('ctaUpgrade.imageAlt')} />
        </div>
        <div className={`${styles['contentWrapper']} ${!planFree ? styles['contentWrapperPro'] : ''}`}>
          <div>
            <label className={styles['avisoLimiteObras']}>
              {isAdmin
                ? t('ctaUpgrade.warningAdmin')
                : t('ctaUpgrade.warningCompany')
              }
            </label>
          </div>
          <h2>
            {planFree
              ? isAdmin
                  ? t('ctaUpgrade.upgradeFreeAdmin')
                  : t('ctaUpgrade.upgradeFreeCompany')
              : isAdmin
                  ? t('ctaUpgrade.upgradeProAdmin')
                  : t('ctaUpgrade.upgradeProCompany')
            }
          </h2>
          <h3>{t('ctaUpgrade.subtitle')}</h3>
          {planFree && (
            <>
              <p>{t('ctaUpgrade.proAlsoProvides')}</p>
              <div className={styles['icons-wrapper']}>
                <div className={`${styles['icons-text-wrapper']} ${styles['icons-text-margin']}`}>
                  <div>
                    <Icon icon={'arquivo3d'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                    <span>{t('ctaUpgrade.feature2d3d')}</span>
                  </div>
                  <div>
                    <Icon icon={'estrelaVazia'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                    <span>{t('ctaUpgrade.featureNomenclature')}</span>
                  </div>
                </div>
                <div className={styles['icons-text-wrapper']}>
                  <div>
                    <Icon icon={'menuGerenciarUsuario'} size={'xs'} customColor={'#8697A8'} />
                    <span>{t('ctaUpgrade.featureUsersRoles')}</span>
                  </div>
                  <div>
                    <Icon icon={'menuPlotagem'} size={'xs'} customColor={'#8697A8'} />
                    <span>{t('ctaUpgrade.featurePlotting')}</span>
                  </div>
                </div>
                <div style={{ marginBottom: 14 }}>&nbsp;</div>
              </div>
            </>
          )}

          <div className={styles['button-wrapper']}>
            <Button
              className={styles['button-confirm']}
              type='primary'
              ispremium="true"
              width={228}
              height={48}
              onClick={() => onConfirm(role || 0, order || 0)}
            >
              <Icon icon="crown" className={styles['icon']} size="xxs" color="cinzaEscuro" />
              {isAdmin
                  ? t('ctaUpgrade.acquirePro')
                  : t('ctaUpgrade.requestPro')
              }
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivitiesCTAUpgrade;
